@if (product$ | async; as product) {
  <div class="flex flex-col">
    <h2 class="text-xl font-bold mt-2">{{ product.title }}</h2>
    @if (product.artbez2) {
      <span class="mt-1 color-light">{{ product.artbez2 }}</span>
    }
    @if (product.artbez3) {
      <span class="mt-1 color-light">{{ product.artbez3 }}</span>
    }
  </div>
  <section class="soft-section mt-3 pb-2">
    <div class="flex flex-row items-center flex-nowrap">
      <lib-product-detail-field
        class="mr-2"
        [label]="'#PRODUCT_SCAN.DETAIL.VKP'"
        [value]="$safeNavigationMigration(product.detailverkaufpriceartstamm?.gross)"
        [businessCardPrice]="$safeNavigationMigration(product?.businesscardpriceartstamm?.gross)"
        [valueType]="'currency'">
      </lib-product-detail-field>
      @if ((product.detailverkaufpriceidentnummer || product?.businesscardpriceidentnummer)) {
        <lib-product-detail-field
          class="ml-2"
          [label]="'#PRODUCT_SCAN.DETAIL.VKP'"
          [value]="$safeNavigationMigration(product.detailverkaufpriceidentnummer?.gross)"
          [businessCardPrice]="$safeNavigationMigration(product?.businesscardpriceidentnummer?.gross)"
          [valueType]="'currency'">
        </lib-product-detail-field>
      }
    </div>
    <div class="flex flex-row items-center flex-nowrap">
      <div class="flex flex-col justify-center flex-nowrap info-box mt-3 mr-2">
        <span class="overline-list custom-color-tertiary mb-1">{{ '#PRODUCT_SCAN.DETAIL.NUMBER' | translate }}</span>
        <div class="color-light">{{product.number}}</div>
      </div>
      <div class="flex flex-col justify-center flex-nowrap info-box mt-3 ml-2">
        <span class="overline-list custom-color-tertiary mb-1">{{ '#PRODUCT_SCAN.DETAIL.ID' | translate }}</span>
        <div class="color-light">{{product.identnumber === '' ? '-' : product.identnumber}}</div>
      </div>
    </div>
    <div class="color-light mb-4">
      @if ((filePaths$ | async)?.length) {
        @for (path of filePaths$ | async; track path) {
          <div class="info-box-image dead-center">
            <img class="fill-container" [attr.src]="path | secureImage | async" alt="product image">
          </div>
        }
      } @else {
        <div class="info-box-image dead-center mb-4">
          <span class="text-sm color-light">{{ '#PRODUCT_SCAN.DETAIL.NO_IMAGE' | translate }}</span>
        </div>
      }
    </div>
  </section>
}


